import React from "react";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const formatarMoeda = (valor) => {
    if (valor === null || valor === undefined || isNaN(valor)) return 'R$ 0,00';
    return Number(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
};

const getStatusProduto = (produto) => {
    if (produto.status === 'Inativo') return { text: 'Inativo', class: 'status-inativo' };
    return { text: 'Ativo', class: 'status-ativo' };
};

function GridProdutos({ arrayProdutos, clickDelete, userPermissions }) {

    if (!arrayProdutos || arrayProdutos.length === 0) {
        return (
            <div className="text-center p-5 text-muted">
                <i className="fas fa-box-open fa-3x mb-3 opacity-50"></i>
                <h4 className="fw-light">Nenhum produto encontrado</h4>
                <p className="mb-0">Não há produtos cadastrados ou que correspondam aos critérios de pesquisa.</p>
            </div>
        );
    }

    return (
        <div className="table-responsive">
            <table className="table table-custom table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th scope="col" className="text-center" style={{ width: '100px' }}>Ações</th>
                        <th scope="col" style={{ width: '100px' }}>Código</th>
                        <th scope="col" className="col-descricao">Descrição</th>
                        <th scope="col" className="col-marca">Marca</th>
                        <th scope="col" className="col-fornecedor">Fornecedor</th>
                        <th scope="col" style={{ width: '140px' }}>Venda</th>
                        <th scope="col" style={{ width: '140px' }}>Compra</th>
                        <th scope="col" style={{ width: '100px' }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayProdutos.map((produto) => {
                        const status = getStatusProduto(produto);
                        const nomeMarca = produto.marca_nome || '-';
                        const nomeFornecedor = produto.fornecedor_nome || '-';

                        return (
                            <tr key={produto.id}>
                                <td className="text-center" data-label="Ações">
                                    <div className="actions-cell">
                                        <Link
                                            to={`/app/editarproduto/${produto.id}`}
                                            className="btn-action-sm btn-edit"
                                            title="Editar"
                                            onClick={(e) => {
                                                // Validation for Edit
                                                if (userPermissions && userPermissions['editar_produtos'] === false) {
                                                    e.preventDefault();
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'Acesso Negado',
                                                        text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                        confirmButtonColor: '#2185c6'
                                                    });
                                                }
                                            }}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Link>
                                        <button onClick={() => clickDelete(produto.id)} className="btn-action-sm btn-delete" title="Excluir">
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                                <td data-label="Código">
                                    <span className="badge bg-light text-dark font-monospace border">{produto.codigo || '-'}</span>
                                </td>
                                <td className="col-descricao" data-label="Descrição">
                                    <div className="d-flex flex-column">
                                        <span className="fw-medium text-dark text-truncate">{produto.descricao || 'Sem descrição'}</span>
                                        {produto.observacoes && (
                                            <small className="text-muted fst-italic text-truncate" style={{ maxWidth: '100%' }}>{produto.observacoes}</small>
                                        )}
                                    </div>
                                </td>
                                <td className="col-marca" data-label="Marca">{nomeMarca}</td>
                                <td className="col-fornecedor" data-label="Fornecedor">{nomeFornecedor}</td>
                                <td className="fw-bold text-success" data-label="Venda">{formatarMoeda(produto.valor_venda)}</td>
                                <td className="text-muted" data-label="Compra">{formatarMoeda(produto.valor_compra)}</td>
                                <td data-label="Status">
                                    <span className={`status-badge-custom ${status.class}`}>
                                        {status.text}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default GridProdutos;